import axios from "axios";
import { CaptureSentryError } from "src/components/Error/SentryUtils";
import { getLocale } from "src/i18n";

const axiosInstance = axios.create({
    baseURL: import.meta.env.VITE_BASE_API_URL,
    headers: {
        "Content-Type": "application/json",
        "Accept-Language": getLocale(),
    },
});

axiosInstance.interceptors.request.use(
    (request) => {
        return request;
    },
    (error) => {
        console.error(error);
    }
);

axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        const data = error.response?.data;
        CaptureSentryError(error, []);
        console.error(error);
        return Promise.reject(
            error.response
                ? {
                      message: typeof data === "string" ? data : "Unknown error",
                      ...error.response,
                  }
                : {
                      message: "Something went wrong with Axios",
                      code: error.code,
                  }
        );
    }
);

export const axiosMonitoring = axios.create({
    baseURL: import.meta.env.VITE_BASE_MONITORING_URL,
    headers: {
        "Content-Type": "application/json",
    },
});

axiosMonitoring.interceptors.request.use(
    (request) => {
        return request;
    },
    (error) => {
        if (axios.isAxiosError(error)) {
            console.error(error.toJSON());
        } else {
            console.error(error);
        }
    }
);

axiosMonitoring.interceptors.response.use(
    (response) => response,
    (error) => {
        const data = error.response?.data;

        console.error(error);
        return Promise.reject(
            error.response
                ? {
                      message: typeof data === "string" ? data : "Unknown error",
                      ...error.response,
                  }
                : { message: "Something went wrong with Axios" }
        );
    }
);

export { axiosInstance as axios };
export default axiosInstance;
